interface MetricsCardProps {
	title: string;
	value: string | number;
	showProgress?: boolean;
	progressValue?: number;
	progressColor?: string;
}

const MetricsCard = ({
	title,
	value,
	showProgress = false,
	progressValue = 0,
	progressColor = '#3B82F6',
}: MetricsCardProps) => {
	return (
		<div className="bg-white rounded-lg border border-gray-200 p-2 shadow-sm hover:shadow-md transition-shadow">
			<div className="space-y-2">
				<h3 className="text-3xl font-bold text-gray-900">{value}</h3>
				<p className="text-sm text-gray-600">{title}</p>
				{showProgress && (
					<div className="pt-2">
						<div className="flex space-x-1">
							{Array.from({ length: 10 }, (_, i) => (
								<div
									key={i}
									className={`h-[16px] w-[8px] rounded-md ${
										i < Math.floor(progressValue / 10) ? 'bg-green-500' : 'bg-gray-200'
									}`}
								/>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default MetricsCard;
